<template>
  <div>
    <div class="block__header-smaller">
      {{ tStatic('newsletterTitle') }}
    </div>
    <p class="block__text block__text--margin">
      {{ tStatic('newsletterDescription') }}
    </p>
    <template v-if="message">
      <div class="input-column">
        <div class="input-column__container">
          {{ message }}
        </div>
      </div>
    </template>
    <template v-else>
      <validation-observer
        ref="observer"
        tag="div">
        <oie-layout-grid class="grid--two">
          <div class="input-column">
            <div class="input-column__container">
              <validation-provider v-slot="{errors}" rules="required|email" slim>
                <oie-base-input
                  id="newsletter-email"
                  v-model="email"
                  :label-text="`${tStatic('email')}`"
                  :placeholder="tStatic('emailPlaceholder')"
                  :max-length="80"
                  :error-messages="errors">
                <!-- <template #iconPrepend>
              <oie-base-icon icon="mail" size="s"></oie-base-icon>
            </template> -->
                </oie-base-input>
              </validation-provider>

              <validation-provider v-slot="{errors}" rules="checked" slim>
                <oie-base-checkbox
                  v-model="acceptTerms"
                  size="large"
                  is-for="register-confirm-terms"
                  css-classes="input-column__checkbox"
                  :errors="errors"
                  :text="tStatic('approveTermsLabel')"></oie-base-checkbox>
              </validation-provider>

              <div>
                <template>
                  <div v-if="errorMessage" class="input__message--error">
                    {{ errorMessage }}
                  </div>
                </template>
              </div>

              <validation-provider
                v-slot="{errors}"
                rules="required"
                mode="passive"
                slim>
                <oie-recaptcha-v2
                  ref="recaptcha"
                  v-model="recaptchaResponse"
                  :errors="errors">
                </oie-recaptcha-v2>
              </validation-provider>

              <oie-base-button
                v-element-loader="{ endpoint: ['newsletter/subscribe'] }"
                css-classes="button--with-border button--blue input-column__button"
                :text="tStatic('registerNewsletterButtonLabel')"
                @click="subscribeAction">
              </oie-base-button>
            </div>
          </div>
        </oie-layout-grid>
      </validation-observer>
    </template>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data: () => ({
    acceptTerms: false,
    email: '',
    message: null,
    errorMessage: null,
    recaptchaResponse: null
  }),
  methods: {
    subscribeAction() {
      this.$refs.observer.validate().then((valid) => {
        if (valid) {
          httpService.post('newsletter/subscribe', { email: this.email, recaptchaResponse: this.recaptchaResponse }).then((response) => {
            this.$refs.recaptcha.reset()
            if(response.data.success) {
              this.errorMessage = ''
              this.message = response.data.information
              setTimeout(() => {
                this.email = ''
                this.acceptTerms = false
                this.message = null
              }, 6000)
            } else {
              this.errorMessage = response.data.information
              setTimeout(() => {
                this.errorMessage = ''
                this.message = null
              }, 6000)
            }
          })
            .catch((error) => {
              console.error('failed register email', error)
            })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.input-column {
  @include media(small) {
    max-width: 32.5rem;
  }
}

.input-column > *:not(:last-child) {
  margin-bottom: measure(full);
}

.input-column__container > *:not(:last-child) {
  margin-bottom: measure(half);
}

.input-column__container--register {
  display: flex;

  > *:first-child {
    margin-right: measure(full);
  }
}

.input-column__header {
  @include body-semi-bold;
  color: color(text-blue);
  margin-bottom: measure(half);
}

.input-column__actions {
  display: flex;
  flex-direction: column;

  .input {
    margin-bottom: measure(full);
  }
}

.input-column__actions > *:last-child {
  margin-bottom: 0;
}

.input-column__checkbox {
  margin-bottom: measure(half);
}

.input-column__button {
  width: 100%;

  @include media(small) {
    width: 18.125rem;
  }
}
</style>
